import React from 'react'
import styled from 'styled-components'

import { DateRange, dateRangeToQuery, dateRangeFromQuery } from 'dateRanges'
import { BaseRouteParams, withNavigation, WithNavigationProps } from 'hocs'
import DateRangePicker from 'uiComponents/popups/comparisonDateRangePicker'
import { DateRangeType } from 'uiComponents/popups/comparisonDateRangePicker/schema'
import OrderSearchField from 'uiComponents/search/searchWithButton'
import { useSelector } from 'react-redux'
import { getListOrderData } from '../redux'

const SearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 26.75rem;
`

const SearchResults = styled.div`
    font-style: italic;
    font-size: 0.875em;
    color: ${(props) => props.theme.colors.textLight};
    margin-left: 1em;
    margin-top: 0.5em;
    margin-bottom: 0.3em;
    font-weight: lighter;
    height: 1.35em;
`
const OrderFiltersContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    height: 84px;
    border-radius: 4px 0px 0px 0px;
    padding: 16px 0px 16px 0px;
    z-index: 1;
`
const LeftSideContainer = styled.div`
    display: flex;
    flex-wrap: no-wrap;
`
const RightSideContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`

interface OrderFiltersProps extends WithNavigationProps<BaseRouteParams> {}

const OrderFilters: React.FC<OrderFiltersProps> = ({ navigation }) => {
    const query = navigation.query()
    const status = useSelector(getListOrderData)

    const onDateRangeChanged = (range: DateRange) => {
        navigation.addQueryWithReplace({ ...dateRangeToQuery(range), page: '1' })
    }

    const onDateRangeTypeChanged = (rangeType: DateRangeType) => {
        navigation.addQueryWithReplace({ dateRangeType: rangeType, page: '1' })
    }

    const dateRange = dateRangeFromQuery(query, 'today')
    const dateRangeType = query.dateRangeType === 'visit' ? 'visit' : 'sale'

    return (
        <OrderFiltersContainer>
            <LeftSideContainer>
                <SearchContainer>
                    <OrderSearchField
                        style={{ width: '31em' }}
                        placeholder="Search by email, order number, order ID, barcode or discount code"
                        disabled={status.isLoading}
                        hideExtendedSearch
                    />
                    <SearchResults>
                        {!status.isLoading ? `${status.data?.results.length || 0} results` : ''}
                    </SearchResults>
                </SearchContainer>
            </LeftSideContainer>
            <RightSideContainer id="orders-filter">
                <DateRangePicker
                    range={dateRange}
                    onChange={onDateRangeChanged}
                    dateRangeTypeDisabled={status.isLoading}
                    dateRangeType={dateRangeType}
                    onDateRangeTypeChange={onDateRangeTypeChanged}
                    allowFutureDateSelection
                />
            </RightSideContainer>
        </OrderFiltersContainer>
    )
}

export default withNavigation(OrderFilters)
